export const BUSINESS_ROLES = Object.freeze({
  COMPANY_ADMIN: "COMPANY_ADMIN",
  COMPANY_MANAGER: "COMPANY_MANAGER",
  UNIT_ADMIN: "UNIT_ADMIN",
  SUPER_ADMIN: "SUPER_ADMIN",
})

export const BUSINESS_PERMISSIONS = Object.freeze({
  DASHBOARD_VIEW: "BUSINESS_DASHBOARD_VIEW",
  COMPANY_VIEW: "COMPANY_VIEW",
  COMPANY_UPDATE: "COMPANY_UPDATE",
  UNIT_MANAGE: "UNIT_MANAGE",
  SERVICE_MANAGE: "SERVICE_MANAGE",
  DISCOUNT_MANAGE: "DISCOUNT_MANAGE",
  RESERVATION_MANAGE: "RESERVATION_MANAGE",
  CONTENT_MANAGE: "CONTENT_MANAGE",
  COMMENT_REPLY: "COMMENT_REPLY",
  CHAT_MANAGE: "CHAT_MANAGE",
  ADMIN_MANAGE: "ADMIN_MANAGE",
  REPORT_VIEW: "REPORT_VIEW",
})

const allPermissions = Object.values(BUSINESS_PERMISSIONS)

export const BUSINESS_ROLE_PERMISSIONS = Object.freeze({
  [BUSINESS_ROLES.SUPER_ADMIN]: allPermissions,
  [BUSINESS_ROLES.COMPANY_ADMIN]: allPermissions,
  [BUSINESS_ROLES.COMPANY_MANAGER]: allPermissions,
  [BUSINESS_ROLES.UNIT_ADMIN]: [
    BUSINESS_PERMISSIONS.DASHBOARD_VIEW,
    BUSINESS_PERMISSIONS.COMPANY_VIEW,
    BUSINESS_PERMISSIONS.SERVICE_MANAGE,
    BUSINESS_PERMISSIONS.DISCOUNT_MANAGE,
    BUSINESS_PERMISSIONS.RESERVATION_MANAGE,
    BUSINESS_PERMISSIONS.CONTENT_MANAGE,
    BUSINESS_PERMISSIONS.COMMENT_REPLY,
    BUSINESS_PERMISSIONS.REPORT_VIEW,
  ],
})

export const BUSINESS_ALLOWED_ROLES = Object.freeze(Object.values(BUSINESS_ROLES))

export const normalizeAuthList = value => {
  if (Array.isArray(value)) return value.filter(Boolean).map(String)
  if (!value) return []

  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value)
      if (Array.isArray(parsed)) return parsed.filter(Boolean).map(String)
    }
    catch {
      // The API may return a single role or a comma-separated role list.
    }

    return value.split(",").map(item => item.trim()).filter(Boolean)
  }

  return [String(value)]
}
